module.exports = __webpack_public_path__ + "img/static__image.705aa9a5.png";